// components/industry-templates/ArchitectureEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Ruler, Building, Layers, Award } from 'lucide-react';

export const ArchitectureEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Architecture Showcase */}
      {industryData?.architecture_showcase && (
        <Card className="border-0 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Building className="w-8 h-8" style={{ color: theme.primary }} />
              Architecture Showcase
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              {industryData.architecture_showcase.map((project: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl">
                  <h3 className="text-xl font-bold text-white mb-2">{project.name}</h3>
                  <p className="text-slate-300 text-sm mb-3">{project.architect}</p>
                  <Badge style={{ backgroundColor: theme.primary }}>{project.style}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Design Workshops */}
      {industryData?.design_workshops && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Ruler className="w-6 h-6" style={{ color: theme.primary }} />
              Design Workshops
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.design_workshops.map((workshop: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border-l-4" style={{ borderColor: theme.primary }}>
                  <h4 className="font-bold text-white">{workshop.topic}</h4>
                  <p className="text-sm text-slate-400">{workshop.instructor}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
